import { SUPABASE_IMAGE_BASE_URL } from './constants';

export const IMAGE_SIZES = {
  THUMBNAIL: '200x200',
  MEDIUM: '400x400',
  LARGE: '800x800',
  SOCIAL: '1200x630'
} as const;

export const getOptimizedImageUrl = (
  imagePath: string, 
  size: string,
  options: { quality?: number; blur?: boolean } = {}
) => {
  const baseUrl = `${SUPABASE_IMAGE_BASE_URL}${imagePath}`;
  const [width, height] = size.split('x');
  const params = new URLSearchParams({
    width,
    height,
    quality: (options.quality || 75).toString(),
    fit: 'contain',
    ...(options.blur ? { blur: '100' } : {})
  });

  return `${baseUrl}?${params.toString()}`;
};

// Précharger une image
export const preloadImage = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = reject;
    img.src = src;
  });
}; 